<app-banner [heading]="'OUR INFRA - COMPUTER LAB'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/computerlab/computer-lab-1.jpg" alt="best school in kurukshetra">
            </div>
			<div class="about-img">
              <img src="assets/img/infra/computerlab/computer-lab-6.jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-lg-8 col-md-6">
            <div class="about-content">
              <h6 class=""> Computer Lab</h6>
              
              <p>In the age of IT , computers have become a necessity. To cater to this need, the school 
			  has fully loaded and user friendly computer lab.<br><br> The lab is well equipped with latest 
			  technology and a network binding them together.Internet facility with broadband connection
			  paves the way for the students to become highly skilled resource persons and technocrats 
			  in the near future.<br><br>We understand the importance of Computer Literacy &amp; proficient students 
			  can do wonders in the field of Information Technology.
			  
			  </p>
              
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/computerlab/computer-lab-2.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/computerlab/computer-lab-3.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/computerlab/computer-lab-4.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-12 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/computerlab/computer-lab-5.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  
		</div>
      </div>
	</section><!-- End About Section -->
	

	
	
    
    
  </main>